var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$i18n.locale,attrs:{"id":"app"}},[_c('RwvNavMenu'),_c('div',{staticClass:"container"},[_c('RwvHeader'),_c('router-view'),_c('RwvFooter')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }